import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Menu, X, Shield, LayoutDashboard, LogOut, HelpCircle, ShoppingBag } from "lucide-react";
import { useState } from "react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <nav className="sticky top-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
        <Link to="/" className="font-outfit text-2xl font-bold tracking-tight text-[#D4AF37]" data-testid="brand-logo">
          Prestigious Wireless
        </Link>
        <div className="hidden md:flex items-center gap-6">
          <Link to="/faq" className="text-[#A0A0A0] hover:text-[#D4AF37] transition-colors flex items-center gap-1.5 text-sm" data-testid="nav-faq">
            <HelpCircle className="w-4 h-4" /> FAQ
          </Link>
          <Link to="/store" className="text-[#A0A0A0] hover:text-[#D4AF37] transition-colors flex items-center gap-1.5 text-sm" data-testid="nav-store">
            <ShoppingBag className="w-4 h-4" /> Store
          </Link>
          {user ? (
            <>
              <Link to="/dashboard" className="text-[#A0A0A0] hover:text-[#D4AF37] transition-colors flex items-center gap-1.5 text-sm" data-testid="nav-dashboard">
                <LayoutDashboard className="w-4 h-4" /> Dashboard
              </Link>
              {user.role === "admin" && (
                <Link to="/admin" className="text-[#A0A0A0] hover:text-[#D4AF37] transition-colors flex items-center gap-1.5 text-sm" data-testid="nav-admin">
                  <Shield className="w-4 h-4" /> Admin
                </Link>
              )}
              <button onClick={handleLogout} className="text-[#A0A0A0] hover:text-red-400 transition-colors flex items-center gap-1.5 text-sm" data-testid="nav-logout">
                <LogOut className="w-4 h-4" /> Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-[#A0A0A0] hover:text-[#F5F5F5] transition-colors text-sm" data-testid="nav-login">Sign In</Link>
              <Link to="/signup" className="bg-[#D4AF37] hover:bg-[#F0C541] text-black px-6 py-2.5 rounded-full font-semibold text-sm transition-all duration-300 hover:-translate-y-0.5" data-testid="nav-register">Get Started</Link>
            </>
          )}
        </div>
        <button className="md:hidden text-[#F5F5F5]" onClick={() => setMobileOpen(!mobileOpen)} data-testid="mobile-menu-toggle">
          {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {mobileOpen && (
        <div className="md:hidden border-t border-white/10 bg-black/90 backdrop-blur-xl px-6 py-4 space-y-3">
          <Link to="/faq" className="block text-[#A0A0A0] hover:text-[#D4AF37] py-2" onClick={() => setMobileOpen(false)}>FAQ</Link>
          <Link to="/store" className="block text-[#A0A0A0] hover:text-[#D4AF37] py-2" onClick={() => setMobileOpen(false)}>Store</Link>
          {user ? (
            <>
              <Link to="/dashboard" className="block text-[#A0A0A0] hover:text-[#D4AF37] py-2" onClick={() => setMobileOpen(false)}>Dashboard</Link>
              {user.role === "admin" && <Link to="/admin" className="block text-[#A0A0A0] hover:text-[#D4AF37] py-2" onClick={() => setMobileOpen(false)}>Admin</Link>}
              <button onClick={() => { handleLogout(); setMobileOpen(false); }} className="block text-[#A0A0A0] hover:text-red-400 py-2">Logout</button>
            </>
          ) : (
            <>
              <Link to="/login" className="block text-[#A0A0A0] hover:text-[#F5F5F5] py-2" onClick={() => setMobileOpen(false)}>Sign In</Link>
              <Link to="/signup" className="block bg-[#D4AF37] text-black text-center px-6 py-2.5 rounded-full font-semibold" onClick={() => setMobileOpen(false)}>Get Started</Link>
            </>
          )}
        </div>
      )}
    </nav>
  );
}
